<template>
  <page-header-wrapper>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
<!--            <a-col :md="5" :sm="24">-->
<!--              <a-form-item label="排序" prop="sort">-->
<!--                <a-input v-model="queryParam.sort" placeholder="请输入排序" allow-clear/>-->
<!--              </a-form-item>-->
<!--            </a-col>-->
<!--            <a-col :md="5" :sm="24">-->
<!--              <a-form-item label="短剧id" prop="videoId">-->
<!--                <a-input v-model="queryParam.videoId" placeholder="请输入短剧id" allow-clear/>-->
<!--              </a-form-item>-->
<!--            </a-col>-->
            <template v-if="advanced">
<!--              <a-col :md="5" :sm="24">-->
<!--                <a-form-item label="是否跳转" prop="isJump">-->
<!--                  <a-input v-model="queryParam.isJump" placeholder="请输入是否跳转" allow-clear/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
<!--              <a-col :md="5" :sm="24">-->
<!--                <a-form-item label="轮播图url" prop="bannerUrl">-->
<!--                  <a-input v-model="queryParam.bannerUrl" placeholder="请输入轮播图url" allow-clear/>-->
<!--                </a-form-item>-->
<!--              </a-col>-->
            </template>
            <a-col :md="!advanced && 8 || 24" :sm="24">
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
<!--                <a-button type="primary" @click="handleQuery"><a-icon type="search" />查询</a-button>-->
<!--                <a-button style="margin-left: 8px" @click="resetQuery"><a-icon type="redo" />重置</a-button>-->
<!--                <a @click="toggleAdvanced" style="margin-left: 8px">-->
<!--                  {{ advanced ? '收起' : '展开' }}-->
<!--                  <a-icon :type="advanced ? 'up' : 'down'"/>-->
<!--                </a>-->
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations" style="margin-bottom: 16px;">
        <a-space :wrap="true">
          <!-- v-hasPermi="['banner:banner:add']" -->
          <a-button type="primary" @click="$refs.createForm.handleAdd()">
            <a-icon type="plus" />{{ $t('common.add') }}
          </a-button>
          <!-- v-hasPermi="['banner:banner:remove']" -->
          <a-button type="danger" :disabled="multiple" @click="handleDelete">
            <a-icon type="delete" />{{ $t('common.delete') }}
          </a-button>
          <a-button @click="handleBannerSecond">
            <a-icon type="setting" />{{ $t('banner.bannerVideoSecond') }}
          </a-button>

        </a-space>
        <table-setting
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList" />
      </div>
      <!-- 增加修改 -->
      <create-form
        ref="createForm"
        @ok="getList"
      />
      <!-- 轮播图视频播放秒数配置弹框 -->
      <a-modal
        :title="$t('banner.bannerVideoSecond')"
        :visible="bannerSecondVisible"
        @ok="handleSaveBannerSecond"
        @cancel="handleCancelBannerSecond"
        :confirmLoading="saveLoading"
      >
<!--        <a-form-item label="轮播图视频播放秒数">-->
<!--          <a-input-number-->
<!--            v-model="bannerSecondValue"-->
<!--            :min="0"-->
<!--            :precision="0"-->
<!--            :placeholder="$t('banner.inputDisplaySecond')"-->
<!--            style="width: 100%"-->
<!--          />-->
<!--        </a-form-item>-->
        <a-form-item :label="$t('banner.bannerDisplaySecond')">
          <a-input-number
            v-model="bannerDisplaySecondValue"
            :min="0"
            :precision="0"
            :placeholder="$t('banner.inputDisplaySecond')"
            style="width: 100%"
          />
        </a-form-item>
        <a-form-item :label="$t('banner.videoStartSecond')">
          <a-input-number
            v-model="bannerStartSecondValue"
            :min="0"
            :precision="0"
            :placeholder="$t('banner.inputStartSecond')"
            style="width: 100%"
          />
        </a-form-item>

      </a-modal>
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
        :pagination="false"
        :bordered="tableBordered"
        :scroll="{ x: 'max-content' }"
      >
        <span slot="createTime" slot-scope="text, record">
          {{ parseTime(record.createTime) }}
        </span>

        <img style="width: 48px;height: 48px;object-fit: cover;cursor: pointer;" v-image-preview :src="record.bannerUrlIn" slot="bannerUrlIn" slot-scope="text, record">
        <img style="width: 48px;height: 48px;object-fit: cover;cursor: pointer;" v-image-preview :src="record.bannerUrlEn" slot="bannerUrlEn" slot-scope="text, record">
        <video style="width: 100px;max-width: 100%;max-height: 120px;object-fit: contain;" :src="record.videoUrlIn" slot="videoUrlIn" slot-scope="text, record" controls></video>
        <video style="width: 100px;max-width: 100%;max-height: 120px;object-fit: contain;" :src="record.videoUrlEn" slot="videoUrlEn" slot-scope="text, record" controls></video>

        <span slot="isOpen" slot-scope="text, record">
          <a-switch :checkedChildren="$t('common.enable')" :unCheckedChildren="$t('common.disable')" :checked="record.isOpen == 1" @change="changeIsOpen($event,record)"/>
        </span>


        <span slot="operation" slot-scope="text, record">
          <!-- v-hasPermi="['banner:banner:edit']" -->
          <a-divider type="vertical" />
            <!-- v-hasPermi="['banner:banner:edit']" -->
            <a @click="$refs.createForm.handleUpdate(record, undefined)">
              <a-icon type="edit" />{{ $t('common.edit') }}
            </a>

            <!-- v-hasPermi="['banner:banner:remove']" -->
            <a-divider type="vertical" />
            <!-- v-hasPermi="['banner:banner:remove']" -->
            <a @click="handleDelete(record)">
              <a-icon type="delete" />{{ $t('common.delete') }}
            </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="total => $t('table.total', { total })"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
        :rowKey="(record, index) => index + 1"
      />
    </a-card>
  </page-header-wrapper>
</template>

<script>
import { pageBanner,listBanner, delBanner ,changeIsOpen, getBannerConfigs, updateBannerConfigs} from '@/api/banner/banner'
import CreateForm from './modules/CreateForm'
import { tableMixin } from '@/store/table-mixin'
import Video from "@/views/video";

export default {
  name: 'Banner',
  components: {
    Video,
    CreateForm
  },
  mixins: [tableMixin],
  data () {
    return {
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      // 高级搜索 展开/关闭
      advanced: false,
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      ids: [],
      loading: false,
      total: 0,
      // 轮播图视频播放秒数配置
      bannerSecondVisible: false,
      bannerSecondValue: null,
      bannerStartSecondValue: null,
      bannerDisplaySecondValue: null,
      saveLoading: false,
      // 查询参数
      queryParam: {
        sort: null,
        videoId: null,
        isJump: null,
        bannerUrl: null,
        pageNum: 1,
        pageSize: 10
      },
    }
  },
  filters: {
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t('table.index'),
          dataIndex: 'index',
          customRender: (text, record, index) => index + 1,
          width: 80,
          align: 'center',
          fixed: 'left'
        },
        {
          title: this.$t('banner.sort'),
          dataIndex: 'sort',
          width: 80,
          align: 'center'
        },
        {
          title: this.$t('banner.type'),
          dataIndex: 'imgType',
          width: 100,
          align: 'center',
          customRender: (t) => {
            if(t == 0) {
              return this.$t('banner.bannerType')
            }else if(t == 1) {
              return this.$t('banner.adType')
            }
          }
        },
        {
          title: this.$t('banner.jumpType'),
          dataIndex: 'type',
          width: 120,
          align: 'center',
          customRender: (t) => {
            if(t == 0) {
              return this.$t('banner.video')
            }else if(t == 1) {
              return this.$t('banner.externalLink')
            }else if(t == 2) {
              return this.$t('banner.rechargePage')
            }else if(t == 3) {
              return this.$t('banner.signIn')
            }
          }
        },
        {
          title: this.$t('banner.status'),
          dataIndex: 'isOpen',
          width: 100,
          align: 'center',
          scopedSlots: { customRender: 'isOpen' }
        },
        {
          title: this.$t('banner.bannerImage'),
          dataIndex: 'bannerUrlIn',
          width: 120,
          align: 'center',
          scopedSlots: { customRender: 'bannerUrlIn' }
        },
        {
          title: this.$t('banner.video'),
          dataIndex: 'videoUrlIn',
          width: 150,
          align: 'center',
          scopedSlots: { customRender: 'videoUrlIn' }
        },
        {
          title: this.$t('table.createTime'),
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          width: 180,
          ellipsis: true,
          align: 'center'
        },
        {
          title: this.$t('common.operation'),
          dataIndex: 'operation',
          ellipsis: true,
          width: 150,
          scopedSlots: { customRender: 'operation' },
          align: 'center',
          fixed: 'right'
        }
      ]
    }
  },
  created () {
    this.getList()
  },
  watch: {
  },
  methods: {
    /** 查询轮播图列表 */
    getList () {
      this.loading = true
     pageBanner(this.queryParam).then(response => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    changeIsOpen (e,record) {
      record.isOpen = e ? 1 : 0
      record.isOpen = +record.isOpen
      changeIsOpen({id: record.id, isOpen: record.isOpen}).then(response => {
        this.$message.success(
          this.$t('banner.operationSuccess')
        )
        return  record.isOpen = e ? 1 : 0
      })
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        sort: undefined,
        videoId: undefined,
        isJump: undefined,
        bannerUrl: undefined,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    // onShowSizeChange 方法已在 tableMixin 中统一处理，无需重复定义
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map(item => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      const ids = row.id || this.ids
      if(row.id){
        this.ids.push(row.id)
      }
      this.$confirm({
        title: this.$t('banner.confirmDelete'),
        content: this.$t('banner.confirmDeleteContent') + ids,
        onOk () {
          let data = []
          that.ids.map(id => data.push({"id":id}))
          return delBanner(data)
            .then(() => {
              that.onSelectChange([], [])
              that.getList()
              that.$message.success(
                that.$t('common.deleteSuccess'),
                3
              )
          })
        },
        onCancel () {
          //取消清空删除ids列表
          // that.ids = []
        }
      })
    },
    /** 导出按钮操作 */
    handleExport () {
      var that = this
      this.$confirm({
        title: this.$t('banner.confirmExport'),
        content: this.$t('banner.confirmExportContent'),
        onOk () {
          that.download('banner/banner/export', {
            ...that.queryParam
          }, `${that.$t('banner.exportFileName')}_${new Date().getTime()}.xlsx`)
        },
        onCancel () {}
      })
    },
    /** 打开轮播图视频播放秒数配置弹框 */
    handleBannerSecond () {
      this.bannerSecondVisible = true
      this.bannerSecondValue = null
      this.bannerStartSecondValue = null
      this.bannerDisplaySecondValue = null
      // 使用统一接口获取所有配置值
      getBannerConfigs().then(response => {
        const configs = response.data || response
        // 轮播图视频播放秒数
        const bannerSecondValue = configs.bannerSecond
        if (bannerSecondValue !== null && bannerSecondValue !== undefined && bannerSecondValue !== '') {
          const numValue = parseInt(String(bannerSecondValue))
          this.bannerSecondValue = isNaN(numValue) ? 0 : numValue
        } else {
          this.bannerSecondValue = 0
        }
        // 视频从第几秒开始播放
        const bannerTimeValue = configs.bannerTime
        if (bannerTimeValue !== null && bannerTimeValue !== undefined && bannerTimeValue !== '') {
          const numValue = parseInt(String(bannerTimeValue))
          this.bannerStartSecondValue = isNaN(numValue) ? 0 : numValue
        } else {
          this.bannerStartSecondValue = 0
        }
        // 轮播图展示秒数
        const urlTimeValue = configs.urlTime
        if (urlTimeValue !== null && urlTimeValue !== undefined && urlTimeValue !== '') {
          const numValue = parseInt(String(urlTimeValue))
          this.bannerDisplaySecondValue = isNaN(numValue) ? 0 : numValue
        } else {
          this.bannerDisplaySecondValue = 0
        }
      }).catch(() => {
        this.bannerSecondValue = 0
        this.bannerStartSecondValue = 0
        this.bannerDisplaySecondValue = 0
      })
    },
    /** 保存轮播图视频播放秒数配置 */
    handleSaveBannerSecond () {
      if (this.bannerSecondValue === null || this.bannerSecondValue < 0) {
        this.$message.warning(this.$t('banner.inputValidSecond'))
        return
      }
      if (this.bannerStartSecondValue === null || this.bannerStartSecondValue < 0) {
        this.$message.warning(this.$t('banner.inputValidStartSecond'))
        return
      }
      if (this.bannerDisplaySecondValue === null || this.bannerDisplaySecondValue < 0) {
        this.$message.warning(this.$t('banner.inputValidDisplaySecond'))
        return
      }
      this.saveLoading = true
      // 构建配置列表
      const configList = [
        {
          configGroup: 'bannerSecond',
          configKey: 'bannerSecond',
          configValue: String(this.bannerSecondValue)
        },
        {
          configGroup: 'urlTime',
          configKey: 'bannerTime',
          configValue: String(this.bannerStartSecondValue)
        },
        {
          configGroup: 'urlTime',
          configKey: 'urlTime',
          configValue: String(this.bannerDisplaySecondValue)
        }
      ]
      // 使用统一接口批量保存配置
      updateBannerConfigs(configList).then(() => {
        this.$message.success(this.$t('common.updateSuccess'))
        this.bannerSecondVisible = false
        this.saveLoading = false
      }).catch(() => {
        this.saveLoading = false
      })
    },
    /** 取消轮播图视频播放秒数配置 */
    handleCancelBannerSecond () {
      this.bannerSecondVisible = false
      this.bannerSecondValue = null
      this.bannerStartSecondValue = null
      this.bannerDisplaySecondValue = null
    }
  }
}
</script>

<style scoped lang="less">
.table-operations {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;

    .ant-space {
      width: 100%;
    }
  }
}

// 表格响应式优化
:deep(.ant-table-wrapper) {
  .ant-table {
    min-width: 100%;
  }

  .ant-table-body {
    overflow-x: auto;
  }

  // 小屏幕下优化表格显示
  @media (max-width: 768px) {
    .ant-table-thead > tr > th,
    .ant-table-tbody > tr > td {
      padding: 8px 4px;
      font-size: 12px;
    }

    .ant-table-thead > tr > th {
      white-space: nowrap;
    }
  }
}

// 操作按钮优化
:deep(.ant-table-tbody) {
  .ant-space {
    flex-wrap: wrap;
  }

  a {
    white-space: nowrap;
  }
}

// 分页器响应式
.ant-table-pagination {
  @media (max-width: 768px) {
    :deep(.ant-pagination) {
      .ant-pagination-options {
        display: none;
      }
    }
  }
}

// 修复图片预览时固定列未被遮罩的问题
:deep(.ant-table-wrapper) {
  // 降低固定列的 z-index，确保预览遮罩层可以覆盖
  .ant-table-fixed-left,
  .ant-table-fixed-right {
    z-index: 1 !important;
  }

  .ant-table-fixed-left::before,
  .ant-table-fixed-right::before {
    z-index: 1 !important;
  }

  .ant-table-fixed-left .ant-table-thead > tr > th,
  .ant-table-fixed-right .ant-table-thead > tr > th,
  .ant-table-fixed-left .ant-table-tbody > tr > td,
  .ant-table-fixed-right .ant-table-tbody > tr > td {
    z-index: 1 !important;
  }
}
</style>

<!-- 全局样式：确保图片预览遮罩层在表格固定列之上 -->
<style lang="less">
// vue-directive-image-previewer 预览遮罩层样式修复
.image-preview-container,
.image-preview-mask,
[class*="image-preview"],
[class*="preview-mask"],
[class*="preview-container"] {
  z-index: 1000 !important;
}

// 确保预览相关的所有元素都在表格固定列之上
body > div[class*="preview"],
body > div[class*="image-preview"] {
  z-index: 1000 !important;
}
</style>
